import apiFetch from '../../../utils/apiFetch';

const post = async (url, body, fallback) => {
  const response = await apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || fallback);
  return result;
};

/** Blink Steps (Boon of Dimensional Travel): the server checks the action taken and the 30 feet, then moves the token. */
export const spendBlinkSteps = (characterId, { eventId, placement }) =>
  post(`/characters/${encodeURIComponent(characterId)}/boons/blink-steps`, { eventId, placement }, 'Blink Steps could not be saved.');

/** The Night Spirit: `shadow-on`, `shadow-off` or `merge` (Merge with Shadows). */
export const sendNightSpirit = (characterId, { action, eventId }) =>
  post(`/characters/${encodeURIComponent(characterId)}/boons/night-spirit`, { action, eventId }, 'The Night Spirit could not be saved.');
